import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AiService {

  private _travelapiUrl = `${environment.travel}`;

  constructor(
    private _http : HttpClient
  ) { }

  getAiGeneratedRouteCraftHtml(formData: any): Observable<string> {
    return this._http.post<string>(`${this._travelapiUrl}/AIRouteDownloadAsHTML`, formData, { responseType: 'text' as 'json' });
  }

  getAiGeneratedRouteCraftJson(formData:any): Observable<any>{
    return this._http.post<any>(`${this._travelapiUrl}/AIRoute`, formData);
  }
  
}
